import { render, staticRenderFns } from "./StatusGorunumCellRenderer.vue?vue&type=template&id=9bdcdbc4"
import script from "./StatusGorunumCellRenderer.vue?vue&type=script&lang=js"
export * from "./StatusGorunumCellRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports